import { Predicate, Query } from "@syncfusion/ej2-data";
import { IDiscriminator, IParentDiscriminator } from "../../lib/types";

export const isParentDiscriminator = (
  discriminator: IParentDiscriminator | IDiscriminator
): discriminator is IParentDiscriminator => {
  return (
    "parentEntityType" in discriminator || "parentEntityId" in discriminator
  );
};

export const getDiscriminatorPredicate = (
  discriminator: IParentDiscriminator | IDiscriminator
): Predicate | null => {
  let predicate: Predicate | null = null;
  if (discriminator.entityType) {
    predicate = new Predicate(
      "entityType",
      "equal",
      discriminator.entityType,
      true
    );
  }

  if (discriminator.entityId) {
    const entityIdPredicate = new Predicate(
      "entityId",
      "equal",
      `'${discriminator.entityId}'`,
      true
    );
    if (predicate) {
      predicate = predicate.and(entityIdPredicate);
    } else {
      predicate = entityIdPredicate;
    }
  }

  if (isParentDiscriminator(discriminator)) {
    if (discriminator.parentEntityType) {
      predicate = new Predicate(
        "parentEntityType",
        "equal",
        discriminator.parentEntityType,
        true
      );
    }

    if (discriminator.parentEntityId) {
      predicate = new Predicate(
        "parentEntityId",
        "equal",
        discriminator.parentEntityId,
        true
      );
    }
  }

  return predicate;
};

export const getDiscriminatorQuery = (
  discriminator: IParentDiscriminator | IDiscriminator,
  query: Query = new Query()
): Query => {
  const predicate = getDiscriminatorPredicate(discriminator);
  if (predicate) {
    query = query.where(predicate);
  }

  return query;
};

export const applyPredicate = (
  query: Query | undefined | null,
  predicate: Predicate | undefined | null
) => {
  let clonedQuery = query ? query.clone() : new Query();
  if (predicate) {
    // todo handle multiple onWhere queries - should not happen though.
    const onWhereQuery = clonedQuery.queries.find(
      (query) => query.fn === "onWhere"
    );
    if (onWhereQuery && onWhereQuery.e?.predicates) {
      let mergedPredicate = onWhereQuery.e.predicates[0];
      for (let i = 1; i < onWhereQuery.e.predicates.length; i++) {
        if (onWhereQuery.e.condition === "or") {
          mergedPredicate = mergedPredicate.or(onWhereQuery.e.predicates[i]);
        } else {
          mergedPredicate = mergedPredicate.and(onWhereQuery.e.predicates[i]);
        }
      }
      onWhereQuery.e.predicates = [predicate.and(mergedPredicate)];
    } else {
      clonedQuery = clonedQuery.where(predicate);
    }
  }

  return clonedQuery;
};
